import cn from "classnames";
import { dateTimeToView } from "helpers/date";
import { bidStatusesEnum } from "helpers/enums";
import { ymEvent } from "helpers/system";
import Pencil from "icons/planning/pencil.svg";
import { UmamiManager } from "lib/umami";
import Tooltip from "rc-tooltip";
import React, { useMemo, useState } from "react";
import { resetCache } from "sources/tripPlanning";

export default function EndDates(props) {
    const { data, modal, roles } = props;

    const [estimatedEndDate, setEstimatedEndDate] = useState(data.estimatedEndDate);
    const [manualEstimatedLeaveDate, setManualEstimatedEndDate] = useState(data.manualEstimatedLeaveDate);
    const [comment, setComment] = useState(data.estimationComment);

    const { plannedEndDate, bidStatus, lastPointEnteredAtByLogistOrAuto } = data;

    const isLate = useMemo(() => new Date(plannedEndDate).getTime() < new Date(estimatedEndDate).getTime(), []);
    const canSetBidEstimatedLeaveDate = useMemo(() => {
        const { Done, Started } = bidStatusesEnum;
        const { isTruckingOrganizationAdmin, isTruckingOrganizationManager, isTruckingOrganizationHeadLogist } = roles;
        return (
            (isTruckingOrganizationAdmin || isTruckingOrganizationManager || isTruckingOrganizationHeadLogist) &&
            [Started, Done].includes(bidStatus)
        );
    }, [lastPointEnteredAtByLogistOrAuto, roles, bidStatus]);
    const setEstimatedLeaveDate = () => {
        const { bidId, to } = data;

        UmamiManager.track("ReleaseDateFieldClicked");
        ymEvent("TripPlanningEstimatedLeaveDateUsed");

        return modal({
            name: "setBidEstimatedLeaveDate",
            title: "Изменить расчетное время выезда",
            windowMod: "sm",
            refreshData: (newData) => {
                UmamiManager.track("ReleaseDateWindowPencilIconClicked");
                ymEvent("TripPlanningEstimatedLeaveDateUsed");

                if (newData) {
                    setEstimatedEndDate(newData.date);
                    setManualEstimatedEndDate(newData.date);
                    setComment(newData.comment);
                } else {
                    setManualEstimatedEndDate(null);
                    setComment(null);
                }
                resetCache();
            },
            bidPoint: {
                planEnterDateOffset: plannedEndDate, // for display timezone in last point
                geozone: { address: to.city },
            },
            manualEstimatedLeaveDate,
            comment,
            bid: { id: bidId },
        });
    };

    return (
        <div className="w-100">
            <div className="ellipsis" data-test-id="trip-planning-planned-end-date">
                Плановая&nbsp;
                {dateTimeToView(plannedEndDate, "DD.MM.YYYY HH:mm (Z)")}
            </div>
            <div className="d-inline-flex w-100">
                <div className="flex-grow-1 overflow-hidden">
                    <div
                        className={cn("ellipsis", { "p-cell--text-danger": isLate, "p-cell--text-success": !isLate })}
                        data-test-id="trip-planning-estimated-end-date"
                    >
                        {comment ? (
                            <Tooltip overlay={comment}>
                                <span>
                                    Расчетная&nbsp;
                                    {dateTimeToView(
                                        manualEstimatedLeaveDate ?? estimatedEndDate,
                                        "DD.MM.YYYY HH:mm (Z)",
                                    )}
                                </span>
                            </Tooltip>
                        ) : (
                            <span>
                                Расчетная&nbsp;
                                {dateTimeToView(manualEstimatedLeaveDate ?? estimatedEndDate, "DD.MM.YYYY HH:mm (Z)")}
                            </span>
                        )}
                    </div>
                </div>
                {canSetBidEstimatedLeaveDate && (
                    <Pencil
                        className="cursor-pointer"
                        data-test-id="trip-planning-edit-estimated-end-date"
                        onClick={setEstimatedLeaveDate}
                    />
                )}
            </div>
        </div>
    );
}
